<template>
  <div>
    <table-manager :tableData="tableData" ref="tableForm"></table-manager>
    <div class="footerBtn">
      <el-button @click="pre">上一步</el-button>
      <el-button class="mainBtn" @click="save">保存</el-button>
      <el-button class="mainBtn" @click="next">保存并下一步</el-button>
    </div>
  </div>
</template>

<script>
import TableManager from "../AgencyTable";
import comMixin from "common/js/mixin/comMixin";
import { getReportDetail, updateRecordBasic } from "common/js/api";

export default {
  components: {
    TableManager
  },

  data() {
    return {
      tableData: {},
      codeId: this.$route.query.codeId,
      step: 0
    };
  },

  mixins: [comMixin],

  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      const res = await getReportDetail(this.codeId);
    
      this.tableData = res.result.basic;
    },

    async save() {
      const form = this.$refs.tableForm.form;
     
      const res = await updateRecordBasic(form);
      this.$message({
        message: "保存基本信息成功",
        type: "success"
      });
      return true;
    }
  }
};
</script>

<style>
</style>
